import { autoinject } from 'aurelia-framework';

import { GenericApi } from '~/api/generic-api';
import { EntityType } from '~/models/entities/entity-type';
import { SearchResponse } from '~/models/search-response';
import { FetchUtils } from '~/utils/fetch-utils';

export interface EmployerSearchResult {
	entityType: EntityType.EMPLOYER;
	values: PayrollDetailsSearchValuesBackend;
	// NOTE: Jake: 2019-10-08
	// We can fill our fieldModel details later if they
	// came through
	// fieldModel?: undefined;
}

export interface EmployerResult {
	entityType: EntityType.EMPLOYER;
	values: PayrollDetailsValuesBackend;
	// fieldModel?: undefined;
}

interface PayrollDetailsSearchValuesBackend {
	COz_Aust_Company_No: string;
	COz_Payroll: string;
	COz_Payroll_Name: string;
	COz_Fund: string;
}

interface PayrollDetailsValuesBackend
	extends PayrollDetailsSearchValuesBackend {
	COc_Adjust_Cycle: string;
	COc_Comments: string;
	COc_Confirmed: string;
	COc_Cont_Return_Type: string;
	COc_Dummy_Employer: string;
	COc_Employer_STD: string;
	COc_Exception: string;
	COc_Fee_Process_Freq: string;
	COc_File_Format: string;
	COc_Group_Processing: string;
	COc_Halt_Corr: string;
	COc_Individual_Mbrs: string;
	COc_Overnight: string;
	COc_Payroll_Freq: string;
	COc_Payroll_Running: string;
	COc_Payroll_Type: string;
	COc_Proc_Frequency: string;
	COc_Returned_Mail: string;
	COc_Round_Cont: string;
	COc_Sal_Cont_Def: string;
	COc_Scheme_Part: string;
	COc_Sensitive_Empl: string;
	COc_Treasury_Funded: string;
	COc_Units_Processed: string;
	COc_Web_Cont_Flag: string;
	COc_Weekly_Adjust: string;
	COd_First_Pay: string;
	COd_Last_Fee: null;
	COd_Last_Pay: null;
	COd_Paid_Conts_To: null;
	COd_Review: null;
	COd_Termination: null;
	COf_Brkr_Pcnt01: string;
	COf_Brkr_Pcnt02: string;
	COf_Brkr_Pcnt03: string;
	COf_Brkr_TrailPcnt01: string;
	COf_Brkr_TrailPcnt02: string;
	COf_Brkr_TrailPcnt03: string;
	COf_Cas_Cont_Ins_Def: string;
	COf_Cont_Ins_Def: string;
	COf_DTH_Auto_Cover: string;
	COf_DTH_GO_Pcnt_Load: string;
	COf_Non_Cont_Ins_Def: string;
	COf_SC_Auto_Cover: string;
	COf_SC_GO_Pcnt_Load: string;
	COf_Subsidy: string;
	COf_TPD_Auto_Cover: string;
	COf_TPD_GO_Pcnt_Load: string;
	COf_Transfer_Pending: string;
	COi_Identity: string;
	COk_Modified: string;
	COl_Merge_Tran: string;
	COn_US_ID_Modified: string;
	COs_Cont_Files: string;
	COs_Cycle_No: string;
	COs_Rounding_Amt: string;
	COs_Spare_Field: string;
	COz_Add_C_Given: string;
	COz_Add_C_Phone: string;
	COz_Add_C_Position: string;
	COz_Add_C_Surname: string;
	COz_Add_C_Title: string;
	COz_Addr_DPID: string;
	COz_Addr_Status: string;
	COz_Address_Line_101: string;
	COz_Address_Line_102: string;
	COz_Address_Line_103: string;
	COz_Association: string;
	COz_BSB_No: string;
	COz_BSB_No2: string;
	COz_Bank_Acct_Name: string;
	COz_Bank_Acct_Name2: string;
	COz_Bank_Acct_No: string;
	COz_Bank_Acct_No2: string;
	COz_Bpay_Ref: string;
	COz_Broker_Codes01: string;
	COz_Broker_Codes02: string;
	COz_Broker_Codes03: string;
	COz_CEMTEX_Change: string;
	COz_C_Phone_No_Bus: string;
	COz_Contact_Given: string;
	COz_Contact_Name: string;
	COz_Contact_Position: string;
	COz_Contact_Surname: string;
	COz_Contact_Title: string;
	COz_CorresAddrStatus: string;
	COz_Corres_Address01: string;
	COz_Corres_Address02: string;
	COz_Corres_Address03: string;
	COz_Corres_Country: string;
	COz_Corres_Ctry_Code: string;
	COz_Corres_DPID: string;
	COz_Corres_Post_Code: string;
	COz_Country: string;
	COz_Country_Code: string;
	COz_Date_Joined_Plan: string;
	COz_Delegate: string;
	COz_Deleted: string;
	COz_Dth_Risk_Rating: string;
	COz_Email: string;
	COz_Extra_Addr_Line: string;
	COz_Extra_Addr_Line2: string;
	COz_Fax_No: string;
	COz_File_Type_Id: string;
	COz_Given_Names01: string;
	COz_Given_Names02: string;
	COz_Given_Names03: string;
	COz_Given_Names04: string;
	COz_Given_Names05: string;
	COz_Given_Names06: string;
	COz_Group: string;
	COz_Group_Tax_No: string;
	COz_ISO_Industry_Std: string;
	COz_Institution: string;
	COz_Long_Payroll: string;
	COz_Merged_With: string;
	COz_Mobile_Phone: string;
	COz_Old_Home_Phone: string;
	COz_Organiser: string;
	COz_Post_Code: string;
	COz_Reg_Address01: string;
	COz_Reg_Address02: string;
	COz_Reg_Address03: string;
	COz_Reg_Post_Code: string;
	COz_Reporting_Centre: string;
	COz_SC_Risk_Rating: string;
	COz_Sector: string;
	COz_Servicing_Agent: string;
	COz_Set_No: string;
	COz_Sort_Order: string;
	COz_Spare: string;
	COz_Surname01: string;
	COz_Surname02: string;
	COz_Surname03: string;
	COz_Surname04: string;
	COz_Surname05: string;
	COz_Surname06: string;
	COz_TPD_Risk_Rating: string;
	COz_Term_Reason: string;
	COz_Title01: string;
	COz_Title02: string;
	COz_Title03: string;
	COz_Title04: string;
	COz_Title05: string;
	COz_Title06: string;
	COz_Trade_Name: string;
	COz_Web_Address: string;
}

@autoinject
export class EmployerSearchApi {
	public getSearchResults(
		query: string,
	): Promise<SearchResponse<EmployerSearchResult>> {
		return FetchUtils.getJSON('api/payroll-details/search', {
			q: query,
			'field-model': true,
		}).then((response: SearchResponse<EmployerSearchResult>) => {
			for (const item of response.data) {
				item.entityType = EntityType.EMPLOYER;
			}
			return response;
		});
	}

	public getEmployer(
		fund: string,
		employer: string,
	): Promise<EmployerResult> {
		return FetchUtils.getJSON('api/payroll-details/:fund/:employer', {
			fund,
			employer,
		}).then((data: EmployerResult): EmployerResult => {
			data.entityType = EntityType.EMPLOYER;
			return data;
		});
	}
}
